module.exports = __webpack_public_path__ + "img/2025-commitment-header.66232680.png";